import React, { useEffect, useState } from 'react'
import styles from './CreateTripActivityPage.module.scss'
import { Grid, Paper } from '@mui/material'
import { useDispatch } from 'react-redux'
import { useLocation, useParams } from 'react-router-dom'
import CreateTripActivityForm from './CreateTripActivityForm'
import {
  createTripActivitySaga,
  updateTripActivitySaga,
} from '../../../store/trip/actionsTripActivity'
import tripService from '../../../supabaseServices/TripService'
import { defaultFormatDate } from '../../../utils/format'

interface LocationState {
  activity?: {
    location: any
    location_uuid: string
    id: number
    name: string
    category: string
    price: string
    currency: string
    max_capacity: number
    start_time: string
    end_time: string
    description: string
  }
}

const CreateTripActivityPage: React.FC = () => {
  const location = useLocation<LocationState>()
  const activityState = location.state?.activity
  const dispatch = useDispatch()
  const [tripData, setTripData] = useState<any | undefined>(undefined)
  const { tripId } = useParams<{ tripId: string }>()

  const onSubmit = (data: any) => {
    const activityData = { ...data, trip_uuid: tripId }
    if (activityState) {
      dispatch(updateTripActivitySaga({ ...activityData, id: activityState.id }))
    } else {
      dispatch(createTripActivitySaga(activityData))
    }
  }

  useEffect(() => {
    const fetchTripData = async () => {
      try {
        const trip = await tripService.getTripByUUID(tripId)
        if (trip) {
          setTripData(trip)
        }
      } catch (error) {
        console.error('Error fetching trip data:', error)
      }
    }

    fetchTripData()
  }, [tripId])

  const convertedActivity = activityState
    ? {
        ...activityState,
        start_time: activityState.start_time ? new Date(activityState.start_time) : null,
        end_time: activityState.end_time ? new Date(activityState.end_time) : null,
        location: activityState?.location,
      }
    : undefined

  return (
    <main>
      <Grid container spacing={0} py={2}>
        <Grid item xs={12}>
          <div className={styles.mainWrapper}>
            <div className={styles.headerWrapper}>
              <h1>{activityState ? 'Edit Activity' : 'Create Activity'}</h1>
              {tripData && (
                <div className={styles.papersWrap}>
                  <div className={styles.paperItem}>
                    Trip name
                    <Paper elevation={3}>
                      <div className={styles.paper}>{tripData.trip_name}</div>
                    </Paper>
                  </div>
                  <div className={styles.paperItem}>
                    Location
                    <Paper elevation={3}>
                      <div className={styles.paper}>{tripData.location}</div>
                    </Paper>
                  </div>
                  <div className={styles.paperItem}>
                    Start Date
                    <Paper elevation={3}>
                      <div className={styles.paper}>{defaultFormatDate(tripData.start_date)}</div>
                    </Paper>
                  </div>
                  <div className={styles.paperItem}>
                    End Date
                    <Paper elevation={3}>
                      <div className={styles.paper}>{defaultFormatDate(tripData.end_date)}</div>
                    </Paper>
                  </div>
                </div>
              )}
            </div>
            <CreateTripActivityForm onSubmit={onSubmit} initialValues={convertedActivity} />
          </div>
        </Grid>
      </Grid>
    </main>
  )
}

export default CreateTripActivityPage
